import { DELETE_BOOKMARK, ADD_BOOKMARK, CLEAR_BOOKMARK } from '../../actions/actionTypes'

export const addBookmark = payload => ({ type: ADD_BOOKMARK, payload })
export const deleteBookmark = id => ({ type: DELETE_BOOKMARK, id })
export const clearBookmark = () => ({ type: CLEAR_BOOKMARK })


// WEBPACK FOOTER //
// ./src/containers/Bookmark/actions.js